import React from 'react';
import { BadgeAbsolute } from './badge-absolute';
import { StyleProp, ViewStyle } from 'react-native';

interface BadgeWithLabelProps {
  badgeStyle?: StyleProp<ViewStyle>;
  bodyContent: React.ReactNode;
}

export const BadgeAbsoluteWithLabel = ({
  badgeStyle,
  bodyContent,
}: BadgeWithLabelProps) => {
  return <BadgeAbsolute badgeStyle={badgeStyle}>{bodyContent}</BadgeAbsolute>;
};
